import { Link } from 'react-router-dom';
import { useAuth } from '../../context/useAuth';
import type { ToolDefinition } from './toolsData';
import './ToolPlaceholder.css';

interface ToolPlaceholderProps {
  tool: ToolDefinition;
}

export function ToolPlaceholder({ tool }: ToolPlaceholderProps) {
  const { isAuthenticated } = useAuth();
  const isProjectionFeature = tool.status === 'projection-feature';

  return (
    <div className="tool-placeholder">
      <div
        className={`tool-placeholder-card${isProjectionFeature ? ' tool-placeholder-card--projection-feature' : ''}`}
      >
        <span className="tool-placeholder-icon">{tool.icon}</span>
        <h1 className="tool-placeholder-title">{tool.name}</h1>
        <span className={`tool-placeholder-badge tool-placeholder-badge--${tool.tier.toLowerCase()}`}>
          {tool.tier}
        </span>
        {!isProjectionFeature && <p className="tool-placeholder-status">Coming soon</p>}
        <p className="tool-placeholder-description">{tool.description}</p>
        {isProjectionFeature && (
          <div className="tool-placeholder-value-prop">
            <p className="tool-placeholder-callout">
              Available in your projection
            </p>
            <p className="tool-placeholder-cta-text">
              Create a retirement plan to unlock this feature as part of your full projection.
            </p>
            {isAuthenticated ? (
              <Link to="/plan" className="tool-placeholder-cta">
                Go to my plan
              </Link>
            ) : (
              <Link to="/register" className="tool-placeholder-cta">
                Create your free plan
              </Link>
            )}
          </div>
        )}
        <Link to="/tools" className="tool-placeholder-back">
          &larr; Back to all tools
        </Link>
        <p className="tool-placeholder-disclaimer">
          For educational purposes only. Does not constitute financial advice.
        </p>
      </div>
    </div>
  );
}
